import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '@/lib/auth-client';

export function JoinPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const { data, isPending } = useSession();
  const code = params.get('code');

  useEffect(() => {
    if (code) sessionStorage.setItem('pending-invite', code);
  }, [code]);

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        {t('common.loading')}
      </div>
    );
  }

  if (!data?.user) {
    return <Navigate to={`/auth?code=${code ?? ''}`} replace />;
  }

  return <Navigate to="/onboarding" replace />;
}
